import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import ReferenceDate from 'modules/employees/components/ExportEmployeesModal/ExportFields/ReferenceDate'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

const CompanyTimeoffFields = ({ form, onEmployeeSelectionChange }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      <ReferenceDate form={form} />
    </>
  )
}

export default CompanyTimeoffFields
